<main-header [languageOptions]="languageOptions" [userAreaOptions]="userAreaOptions" [currentArea]="currentArea"
    [areaName]="areaName" [currentLangItem]="currentLangItem" (onClickHome)="doClientHome()"
    (onClick)='menuClick($event)' (doClickMbMenu)="doClickMbMenu()" (onSelectArea)='areaSelect($event)'
    (onSelectLanguage)='languageSelect($event)'>header...</main-header>

<div id="menu" [ngClass]="{'wrapper record_side': true, 'close_frame' :!clickheader}">
    <div class="wrapper-size">
        <megamenu [menuList]="mainMenu" (onClick)='menuClick($event)'>
            megamenu...
        </megamenu>

        <mbmenu [menuList]="mainMenu" [clickHeaderEvent]="clickheader" (onClick)='menuClick($event)'>
            mbmenu...
        </mbmenu>

    </div>

</div>

<router-outlet name="mainContent"></router-outlet>
<router-outlet name="subContent"></router-outlet>

<div class="overlayer_menu" (click)="doCloseMbMenu()"
    [ngClass]="{'display-block': clickheader, 'display-none': !clickheader}"></div>

<common-popup-message [showCPMFlag]="showCPMFlag" [cpmViewForm]="cpmViewForm"
    (cpmCallBack)="doPopupCallBack()"></common-popup-message>